import Cookies from '@arsenal/arsenal/modules/Cookies'
import classNames from 'classnames'
import Leaderboard, { IItemInfo } from 'Components/series/leaderboard'
import { IFeedData } from 'lib/fetch-community-feed'
import fetch from 'lib/decorated-fetch'
import React, { useEffect, useMemo, useState } from 'react'
import Popup from './popup'
import { stringify } from 'querystring'
import { get } from 'lodash'
import Article from 'Components/article'
import ScrollLoader from 'Components/scroll-loader'
import Loading from 'Components/loading'
import { Accordion } from '@material-ui/core'
import Favour from 'Components/series/favour'
import CarList from 'Components/series/car-list'
import { sendTeaCommEvent, sendTeaEnterEvent } from 'lib/tea-analyze'
import { logger } from 'lib/slardar-utils'
const empty_icon = require('static/empty-envelope.png')
interface IArticle {
  rankData: IItemInfo[]
  seriesId: number
}

export default function ArticlePage(props: IArticle) {
  const { rankData, seriesId } = props
  const [activeTab, setActiveTab] = useState('recommended')
  const [activeSubTab, setActiveSubTab] = useState('overall')
  const menu = useMemo(
    () =>
      activeSubTab === 'overall'
        ? [
          {
            value: 'recommended',
            text: '推荐资讯',
          },
          {
            value: 'latest',
            text: '最新资讯',
          },
        ]
        : [
          {
            value: 'recommended',
            text: '推荐资讯',
          },
        ],
    [activeSubTab]
  )
  const subMenu = useMemo(
    () => [
      {
        value: 'overall',
        text: '综合',
      },
      {
        value: 'practical',
        text: '实测',
      },
    ],
    []
  )
  useEffect(() => {
    if (activeSubTab === 'practical') {
      setActiveTab('recommended')
    }
  }, [activeSubTab])
  const handleChange = ({ value, text }: { value: string; text: string }) => {
    sendTeaCommEvent('click_article_type_select', {
      obj_text: text,
      car_series_id: seriesId,
    })
    setActiveTab(value)
  }

  const [articles, setArticles] = useState<IFeedData[]>([])
  const [loading, setLoading] = useState(false)
  const [max_behot_time, setMaxBeHotTime] = useState(0)
  const fetchArticles = async (maxBehotTime: number) => {
    let newArticles = []
    const web_id: any = Cookies('tt_webid') || ''
    try {
      const params = {
        concern_id: seriesId,
        category: 'all',
        web_id,
        device_platform: 'web',
        channel: 'web',
        tt_from: 'enter_auto',
        motor_feed_extra_params: JSON.stringify({
          new_feed: true,
          series_page_sort:
            activeSubTab === 'practical' ? undefined : activeTab,
        }),
        sub_category: activeSubTab === 'practical' ? 'pingche' : 'all',
        impression_info: JSON.stringify({
          page_id: 'page_car_series',
          sub_tab: 'all',
        }),
        max_behot_time: maxBehotTime,
        aid: 1839,
      }
      const json = await fetch(
        `/motor/stream_entrance/get_feed/v47/?${stringify(params)}`
      ).catch((e) => {
        // no-op
      })
      newArticles = json?.data || []
      setMaxBeHotTime(
        newArticles?.[newArticles.length - 1]?.info?.behot_time || maxBehotTime
      )
      newArticles = newArticles.filter(
        (e: IFeedData) => e?.type >= 2000 && e?.type < 2300
      )
    } catch (err) {
      // no-op
    }
    if (maxBehotTime > 0) {
      setArticles([...articles, ...newArticles])
    } else {
      setArticles([...newArticles])
    }
  }

  useEffect(() => {
    if (activeTab === 'latest' && activeSubTab === 'practical') {
      // impossible
      logger.warn('最新 实测 同时出现')
      return
    }
    setArticles([])
    setLoading(true)
    fetchArticles(0).finally(() => {
      setLoading(false)
    })
  }, [activeTab, activeSubTab])

  const loadMoreHandler = async () => {
    setLoading(true)
    await fetchArticles(max_behot_time)
    setLoading(false)
  }
  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="left-part">
          <div className="header">
            <Popup menu={menu} active={activeTab} onChange={handleChange} />
            <div className="types">
              {subMenu.map(({ text, value }) => (
                <span
                  className={classNames('item', {
                    active: value === activeSubTab,
                  })}
                  onClick={() => {
                    sendTeaCommEvent('click_article_type_tag', {
                      tag_name: text,
                      car_series_id: seriesId,
                    })
                    setActiveSubTab(value)
                  }}
                  key={value}
                >
                  {text}
                </span>
              ))}
            </div>
          </div>
          {articles.length > 0 ? (
            <>
              <ScrollLoader
                end={false}
                loadMoreHandler={loadMoreHandler}
                loading={loading}
              >
                <div>
                  {articles.map((item, index) => {
                    const info = item?.info || {}
                    return (
                      <Article
                        fromPage={'car_series_home'}
                        type={item.type}
                        key={item.unique_id_str}
                        gid={item.unique_id_str}
                        cover={get(item, 'info.image_list[0].url', '')}
                        duration={info.video_duration}
                        title={info.title}
                        source={info.source}
                        time={info.publish_time * 1000}
                        content={info.abstract_content}
                        index={index}
                        digg_count={info.digg_count}
                        user_digg={info.user_digg}
                        user_info={info.user_info}
                        comment_count={info.comment_count}
                        square_duration
                        onClick={() => {
                          sendTeaCommEvent('click_series_article_list_item', {
                            car_series_id: seriesId,
                            group_id: item.unique_id_str,
                            tag_name: subMenu.find(
                              (item) => item.value === activeSubTab
                            )?.value,
                            article_type: menu.find(
                              (item) => item.value === activeTab
                            )?.value,
                          })
                        }}
                      />
                    )
                  })}
                </div>
              </ScrollLoader>
              {loading && <Loading />}
            </>
          ) : (
            <span className="no-article">
              <img src={empty_icon} />
              暂无文章
            </span>
          )}
        </section>
        <section className="right-part">
          <Leaderboard
            type="article"
            data={rankData}
            className="margin-bottom-8"
            seriesId={seriesId}
          />
          <Favour className="margin-bottom-8" />
          <CarList series_id={seriesId} className="margin-bottom-8" />
        </section>
      </div>
      <style jsx>
        {`
          .content-wrapper {
            width: 1196px;
            margin: 8px auto 0;
            display: flex;
          }
          .left-part {
            width: 868px;
            min-height: 630px;
            padding: 16px;
            margin-right: 8px;
            background-color: white;
            position: relative;
          }
          .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .types {
            display: flex;
            align-items: center;
          }
          .item {
            margin-left: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f7f8fc;
            font-size: 12px;
            line-height: 18px;
            color: #1f2129;
            width: 48px;
            height: 24px;
            border-radius: 2px;
            cursor: pointer;
          }
          .active {
            background-color: #ffcd32;
            border: 1px solid rgba(255, 204, 50, 0.12);
            cursor: default;
          }
          .right-part {
            width: 320px;
          }
          :global(.margin-bottom-8) {
            margin-bottom: 8px;
          }
          .no-article {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #606370;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .no-article > img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            object-position: center;
          }
        `}
      </style>
    </React.Fragment>
  )
}
